// src/services/abstract/OrganizationService.ts
import type { AdminId } from "@/types/administrators.types";
import type {
  OrgProfileDTO, AdminDTO, SeatSummaryDTO, OrgUserDTO,
} from "@/types/organization.dtos";

export abstract class OrganizationService {
  abstract getProfile(id: AdminId): Promise<OrgProfileDTO>;
  abstract getProfileById(id: string): Promise<OrgProfileDTO>;
  abstract getAdmins(): Promise<AdminDTO[]>;
  abstract getSeatSummary(): Promise<SeatSummaryDTO>;
  abstract getUsers(): Promise<OrgUserDTO[]>;
}
